import AdminApproveSidebarComponent from './AdminApproveSidebar.component'

export default AdminApproveSidebarComponent